import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { postponedActionsActions, postponedActionsSelectors } from 'app-components/flux/postponed-actions';

import BuildIcon from '@mui/icons-material/Build';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Snackbar from '@mui/material/Snackbar';

import useQDialogs from 'components/QDialogs/useQDialogs';
import ReportProblemLink from 'components/ReportProblemLink';

const ActionsSnackBar = () => {
  const dispatch = useDispatch();
  const postponedActions = useSelector(postponedActionsSelectors.getPostponedActions);
  const { dialogAlert } = useQDialogs();

  const showDetails = useCallback(
    (actions) => {
      dialogAlert(
        'actions failed',
        actions.map((postponedAction, index) => (
          <div key={postponedAction.key}>
            {`${index + 1}: ${postponedAction.action && postponedAction.action.type} [${postponedAction.error}]`}
          </div>
        )),
        undefined,
        [],
      );
    },
    [dialogAlert],
  );

  const dismissPostponedActions = useCallback(
    (actions) => {
      dispatch(postponedActionsActions.dismissPostponedActions(actions));
    },
    [dispatch],
  );

  const retryPostponedActions = useCallback(
    (actions) => {
      dispatch(postponedActionsActions.dispatchPostponedActions(actions));
    },
    [dispatch],
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={postponedActions && postponedActions.size > 0}
      autoHideDuration={300000}
      onClose={(event, reason) => {
        if (reason !== 'clickaway') {
          dismissPostponedActions(postponedActions);
        }
      }}
    >
      <Alert
        severity='warning'
        action={[
          process.env.NODE_ENV !== 'production' && (
            <IconButton
              key='details'
              aria-label='details'
              color='primary'
              size='small'
              onClick={() => showDetails(postponedActions)}
            >
              <BuildIcon />
              {postponedActions.size}
            </IconButton>
          ),
          <IconButton
            key='close'
            aria-label='Close'
            color='inherit'
            onClick={() => dismissPostponedActions(postponedActions)}
            size='large'
          >
            <CloseIcon />
          </IconButton>,
        ]}
      >
        An error occurred. Please&nbsp;
        <Link id='try-again-id' href='#' onClick={() => retryPostponedActions(postponedActions)}>
          try again.
        </Link>
        <br />
        <ReportProblemLink feedbackSubject='report QCS API error' />
      </Alert>
    </Snackbar>
  );
};

export default ActionsSnackBar;
